import styled from 'styled-components'

import { minmedia, maxmedia } from '../../styles/media-queries'
import { bordergray, white, black, red, lightergray } from '../../styles/colors'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10;

  ${maxmedia.large`
    position: fixed;
    background: ${lightergray};
  `} ${minmedia.large`
    position: fixed;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  `};
`

export const Popup = styled.div`
  position: relative;

  ${maxmedia.large`
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  `} ${minmedia.large`
    overflow: hidden;
    width: 97%;
    max-width: 700px;
    border-radius: 0.25rem;
    background: ${white};
    border: 1px solid ${bordergray};
    box-shadow: 0px 1px 8px 3px rgba(0, 0, 0, 0.2);
  `};
`

export const Inner = styled.div`
  width: 100%;
  padding: 1rem 1.5rem;

  ${minmedia.large`
    padding: 2rem;
  `};
`

export const Header = styled.div`
  width: 100%;
  padding-bottom: 1rem;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  ${minmedia.large`
    padding-bottom: 1.5rem;
  `};
`

export const Title = styled.p`
  text-align: left;
  margin: 0;
  flex: 1;
  font-weight: 800;
  ${minmedia.large`
    font-size: 18px;
  `};
`

export const CloseButton = styled.div`
  cursor: pointer;
  width: 2rem;
  text-align: right;
  margin-top: 0.3rem;

  &:hover {
    fill: ${red};
  }

  svg {
    width: 0.75rem;
    height: 0.75rem;
    fill: ${black};
  }
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  div {
    font-size: 16px;
  }

  ${maxmedia.medium`
    div {
      display: block;
      margin: 0 auto;
      width: 270px;
      max-width: 100%;
      text-align: center;
    }
    div:first-child {
      margin-bottom: .5rem;
    }
    button {
      &:first-child {
        margin-bottom: 1rem;
      }
    }
  `} ${minmedia.medium`
    div:first-child {
      margin-right: 1rem;
    }
    button {
      &:first-child {
        margin-right: 1rem;
      }
    }
  `} @media screen and (max-width: 374px) {
    div {
      font-size: 14px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/SubmitOCIOrderPopup/styles.js